"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExcludeIcon = void 0;
const react_1 = __importDefault(require("react"));
const ui_components_1 = require("@groupby/ui-components");
const SvgIcon_1 = __importDefault(require("@mui/material/SvgIcon"));
const ExcludeIcon = (_a) => {
    var { stroke = ui_components_1.baseColors.primaryBlueMed600 } = _a, props = __rest(_a, ["stroke"]);
    return (react_1.default.createElement(SvgIcon_1.default, Object.assign({ width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props), react_1.default.createElement("circle", { cx: "12", cy: "12", r: "9", stroke: stroke, strokeWidth: "1.36719" }), react_1.default.createElement("path", { d: "M17.5215 5.82129L5.82164 18.3223", stroke: stroke, strokeWidth: "1.36719", strokeLinecap: "round" })));
};
exports.ExcludeIcon = ExcludeIcon;
exports.default = exports.ExcludeIcon;
